import Vue from 'vue'
import { createApp } from 'vue';
import App from '../components/OutletProductsFilter.vue';
import 'vs-vue3-select/dist/vs-vue3-select.css';
import '../styles/pagination.css'
import 'swiper/css';
import 'swiper/css/navigation';

createApp(App).mount('#app');